import React, { lazy } from 'react';
const bonuses = [{
  title: 'Emergency PE Lesson Pack',
  desc: '30 ready-to-teach sessions for the days when you have zero time to plan. Grab a page. Walk in confident.',
  value: '$80',
  img: 'https://cdn.magicpatterns.com/uploads/vrG7iyDZtrhjWMvmA48ykU/b8267152-29fd-4cfb-9b87-dd2727627750-mockup.webp'
}, {
  title: 'No-Prep PE Games Vault',
  desc: '30 high-energy games that require zero equipment. Run them anywhere, anytime, with any class size.',
  value: '$100',
  img: 'https://cdn.magicpatterns.com/uploads/3iJYKdFMLCyqYpVPxF4rKN/5de55cc3-8c82-4c3d-b09c-c3039ef4940f-mockup.webp'
}, {
  title: 'PE Assessment Made Easy',
  desc: '30 plug-and-play assessment pages to track skills, effort, and progress without drowning in paperwork.',
  value: '$70',
  img: 'https://cdn.magicpatterns.com/uploads/aWRYniz1qLLFXqnRAMG1ju/ca23ca72-3c00-479e-8501-d57e025e5f9f-mockup.webp'
}, {
  title: 'The Yearly PE Planning Calendar',
  desc: 'Your entire school year structured from Day 1 to Day 180. Stop guessing what to teach next.',
  value: '$90',
  img: 'https://cdn.magicpatterns.com/uploads/sRLAtgQ2aVSjAZ9XePv2HW/6f2c5f18-fccb-42a2-b53b-905968e885a8-mockup.webp'
}, {
  title: "The PE Teacher's Time-Saving Toolkit",
  desc: '30 practical hacks to reclaim 5 hours of your week, manage class discipline, and teach like a pro.',
  value: '$60',
  img: 'https://cdn.magicpatterns.com/uploads/969WRVxV2gXTczH4L128GT/847cd7d7-ee1b-43ab-8dab-f992ec47bd2f-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 You Also Get{' '}
            <span className="text-[#FF6B00]" data-id="element-5">5 Strategic Bonuses</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium mb-5" data-id="element-6">
            Included at no extra cost
          </p>
          <span className="inline-flex items-center gap-2 bg-[#16161F] border border-[#FF6B0033] rounded-full px-5 py-2.5 text-sm sm:text-base font-bold" data-id="element-7">
            <span className="text-[#B0B0C0]" data-id="element-8">Real value:</span>
            <span className="text-[#FF6B00] line-through" data-id="element-9">$400</span>
            <span className="text-[#B0B0C0]" data-id="element-10">— today included</span>
            <span className="text-[#00C853] font-black uppercase tracking-wider" data-id="element-11">
              FREE
            </span>
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-2xl p-5 flex flex-col" data-id="element-13">
              <div className="relative mb-4 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-14">
                <img src={bonus.img} alt={bonus.title} loading="lazy" className="w-full aspect-square object-cover" width={1024} height={1024} data-id="element-15" />
              </div>
              <div className="flex items-center justify-between mb-3" data-id="element-16">
                <span className="inline-flex items-center gap-1.5 bg-[#FF6B00] text-white font-black text-xs sm:text-sm tracking-wider uppercase px-3 py-1.5 rounded-lg shadow-[0_4px_14px_rgba(255,107,0,0.4)]" data-id="element-17">
                  🎁 Bonus 0{i + 1}
                </span>
                <span className="inline-flex items-center gap-1.5 bg-[#00C853]/10 text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-18">
                  <span className="text-[#FF6B00] line-through" data-id="element-19">
                    {bonus.value}
                  </span>
                  <span className="text-[#00C853]" data-id="element-20">FREE</span>
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-21">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}